import COLORS from './colors';
import { CSSObject } from '@emotion/react';

interface ButtonVariants {
  props: {
    variant: string,
    color?: string
  },
  style: CSSObject,
}

interface Button {
  variants: Array<ButtonVariants>,
}

const button: Button = {
  variants: [
    {
      props: {
        variant: 'contained',
        color: 'primary'
      },
      style: {
        lineHeight: 1.43,
        textTransform: 'none',
        backgroundColor: COLORS.accent,
        color: '#fff',
        padding: '15px 0',
        fontSize: 16,
        fontWeight: 500,
        borderRadius: 12,

        '&:hover': {
          backgroundColor: '#2267EA'
        },
        '&:active': {
          backgroundColor: '#064BCE'
        },
        '&:disabled': {
          backgroundColor: COLORS.gray,
          color: '#fff'
        }
      }
    },
    {
      props: {
        variant: 'outlined',
        color: 'primary'
      },
      style: {
        lineHeight: 1.43,
        textTransform: 'none',
        borderColor: COLORS.accent,
        color: COLORS.accent,
        '&:hover': {
          borderColor: '#2267EA',
          color: '#2267EA',
          background: '#E9F0FF'
        },
        '&:active': {
          borderColor: '#064BCE',
          color: '#064BCE',
          background: '#CFDEFF'
        },
        '&:disabled': {
          borderColor: COLORS.gray,
          color: COLORS.gray,
          background: 'none'
        }
      }
    },
    {
      props: {
        variant: 'text',
        color: 'primary'
      },
      style: {
        lineHeight: 1.43,
        textTransform: 'none',
        color: COLORS.accent,
        border: '1px solid transparent',
        '&:hover': {
          color: '#2267EA',
          background: '#ECF4FF',
          borderColor: '#ECF4FF',
        },
        '&:active': {
          color: '#0F5EF3',
          borderColor: '#0F5EF3',
          backgroundColor: 'transparent',
        },
        '&:focus': {
          color: '#0F5EF3'
        }
      }
    },
    {
      props: {
        variant: 'outlined',
        color: 'secondary'
      },
      style: {
        lineHeight: 1.43,
        textTransform: 'none',
        borderColor: '#6b7793',
        color: '#6b7793',

        '&:hover': {
          borderColor: '#8590B3',
          color: '#8590B3',
          background: '#E7E8ED'
        },
        '&:active': {
          borderColor: '#4E5C8A',
          color: '#4E5C8A',
          background: '#CFD1DA'
        },
        '&:disabled': {
          borderColor: COLORS.gray,
          color: COLORS.gray,
          background: 'none'
        }
      }
    },
    {
      props: {
        variant: 'contained',
        color: 'secondary'
      },
      style: {
        lineHeight: 1.43,
        textTransform: 'none',
        backgroundColor: COLORS.gray,
        color: COLORS.textColor,
        padding: '15px 0',
        fontSize: 16,
        fontWeight: 500,
        borderRadius: 12,

        '&:hover': {
          backgroundColor: COLORS.borderColor
        },
        '&:active': {
          backgroundColor: COLORS.borderColor
        },
        '&:disabled': {
          backgroundColor: COLORS.gray,
          color: '#fff'
        }
      }
    }
  ]
};

export default button;
